import { useState } from "react";
import DatePickerContainer from "../../../UI/DatePicker/DatePickerContainer";
import { getPastYearsToNextDaysDateRange } from "../../../utils/formatters/dateFormatter";
import useDebounceChange from "../../../hooks/useDebounceChange";
import Input from "../../../UI/Form/Input/Input";
import { getUserSelectedDateOption } from "./customDateUtils";
import useToDateFiltersLocalState from "./useToDateFiltersLocalState";
import { defaultDaysQuantityByDomain } from "../../../utils/constants/constants";

export default function FutureDaysAndEarlier(props) {
  const {
    recentMonthsChange,
    activeTabUuid,
    selectedDateType,
    saveStickyDatesToStore,
    dateFiltersConfig,
    dateConfig,
    recentSelectedDatePreset,
    domain,
  } = props;

  const { localState, setLocalState } = useToDateFiltersLocalState(
    dateConfig.tabChanged,
    { days: defaultDaysQuantityByDomain[domain] ?? 1 }
  );

  const { days } = getUserSelectedDateOption(
    dateFiltersConfig,
    activeTabUuid
  ) ?? { ...localState, ...(recentSelectedDatePreset ?? {}) };

  const [validationError, setValidationError] = useState(false);
  const { debounce } = useDebounceChange();

  function onDaysChange(days) {
    if (!days || !Number.isInteger(+days) || +days < 0) {
      return setValidationError("This value must be an positive integer.");
    }

    const { start, end } = getPastYearsToNextDaysDateRange(days, 3);
    debounce(() => recentMonthsChange({ from: start, to: end, days }), 1000);
    setValidationError(false);
    saveStickyDatesToStore(selectedDateType, { from: start, to: end, days });
    setLocalState({ days });
  }

  return (
    <DatePickerContainer>
      <Input
        onChange={(e) => onDaysChange(e.target.value)}
        value={days}
        invalid={validationError}
        errorMessage={validationError}
        data-cy="future-days-input"
      />
    </DatePickerContainer>
  );
}
